
enum PaymentRequiredAction
{
    UserCreation,
}

export default PaymentRequiredAction;
